import React from "react";
import Update from "modules/atmFees/components/Update";

const AtmFeesUpdatePage = () => {
  return <Update />;
};

export default AtmFeesUpdatePage;
